<template>
  <div>
    <b-form-group
      v-for="(limitation, index) in limitations"
      :key="`li${index}`"
    >
      <label :for="`limitation${index}`">{{ labelFor(limitation.type) }}</label>
      <b-input-group>
        <b-form-input
          :id="`limitation${index}`"
          v-model="limitation.amount"
          type="number"
          min="0"
          step="1"
          v-if="limitation.amount > -1"
        />
        <span class="form-control" v-if="limitation.amount === -1" @click="limitation.amount = 0" v-html="formatMaximum(limitation.amount)"/>
        <b-input-group-append>
          <b-button size="sm" variant="info" @click="limitation.amount = -1">
            <i class="fas fa-infinity"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
import poolState from '../_poolState'
import poolLimitations from '../_poolLimitations'

export default {
  props: {
    value: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      poolLimitations
    }
  },
  watch: {
    limitations(limitations) {
      this.$emit('input', poolLimitations)
    }
  },
  methods: {
    labelFor(type) {
      switch(type) {
        case 'test_campaign_creation':
          return 'Kampány:'
        case 'test_rating':
          return 'Értékelés:'
        default:
          return type
      }
    },
    formatMaximum(maximum) {
      if (maximum === -1) {
        return '&infin;'
      } else {
        return maximum
      }
    }
  }
}
</script>